import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';

const { Content } = Layout;

const TeamAdminContent = () => {
  return (
    <Content style={{ padding: '24px 24px' }}>
      <div className='site-layout-content'>
        <Outlet />
      </div>
    </Content>
  );
};

export default TeamAdminContent;
